<template>
  <div>
    <div>
      <!-- 查询条件 -->
      <div class="">
        <div ref="searchBox" class="formBox margbot">
          <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini" label-width="90px">
            <div class="formItemBox">
              <el-form-item label="转货单号:">
                <el-input v-model="formData.changeNo" placeholder="请输入转货单号"></el-input>
              </el-form-item>
              <el-form-item label="转货时间:" >
                <div style="display: flex;">
                  <el-date-picker v-model="formData.approverDateStart" placeholder="请选择" type='datetime' value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  -
                  <el-date-picker v-model="formData.approverDateEnd" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="原一级货主:">
                <el-select v-model="formData.oldPrimaryCustomerId" filterable placeholder="请选择" clearable>
                  <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="原二级货主:">
                <el-select v-model="formData.oldSecondaryCustomerId" filterable placeholder="请选择" clearable>
                  <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:">
                <el-select v-model="formData.productType" placeholder="请选择" clearable>
                  <el-option v-for="item in HwData" :key="item.productType" :label="item.productTypeName" :value="item.productType"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="现一级货主:">
                <el-select v-model="formData.newPrimaryCustomerId" filterable placeholder="请选择" clearable>
                  <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="现二级货主:">
                <el-select v-model="formData.newSecondaryCustomerId" filterable placeholder="请选择" clearable>
                  <el-option v-for="(item,index) in SHData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转货类型:">
                <el-select v-model="formData.changeType" placeholder="请选择" clearable>
                  <el-option v-for="item in changeTypeOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户单号:">
                <el-input v-model="formData.customerChangNo" placeholder="请输入客户单号"></el-input>
              </el-form-item>
            </div>
            <el-form-item style="padding-left: 10px;">
              <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB00C" v-if="btnFlg[11]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB00D" v-if="btnFlg[12]">重置</el-button>
              <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB00E" v-if="btnFlg[13]">导出</el-button>
              <el-button type="primary" size="mini" @click="chexiao" btnCode="00cP00BB00F" v-if="btnFlg[14]">撤销</el-button>
              <el-button type="primary" size="mini" @click="beizhuBtn" btnCode="00cM0D0100" v-if="btnFlg[39]">记录备注
              </el-button>
            </el-form-item>
            <div style="margin: 0 0 5px 10px">
              <span>总吨数:
                <span style="color:red">{{allWeight}}</span>吨
              </span>
              <span>总件数:
                <span style="color:red">{{ number }}</span>件
              </span>
            </div>
          </el-form>
        </div>
        <div :style="{ height: h }">
          <el-table @selection-change='selectGoods' height="100%" style="width:100%" size="mini" :data="detailsData" :header-cell-style="{ background: '#F5F5F5',color: 'black',}" border center bordersize="mini" highlight-current-row @row-click='dianjixuanzhong'>
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column prop="changeTypeName" label="转货类型" align="center" :show-overflow-tooltip="true" width="120"></el-table-column>
            <el-table-column prop="approverDate" label="转货时间" align="center" :formatter="dateTimeFormat" :show-overflow-tooltip="true" width="180"></el-table-column>
            <el-table-column prop="customerChangNo" :show-overflow-tooltip="true" label="客户单号" align="center" width="280"></el-table-column>
            <el-table-column prop="oldPrimaryCustomerName" :show-overflow-tooltip="true" label="原一级货主" align="center" width="220"></el-table-column>
            <el-table-column prop="oldSecondaryCustomerName" :show-overflow-tooltip="true" label="原二级货主" align="center" width="220"></el-table-column>
            <el-table-column prop="newPrimaryCustomerName" :show-overflow-tooltip="true" label="现一级货主" align="center" width="220"></el-table-column>
            <el-table-column prop="newSecondaryCustomerName" :show-overflow-tooltip="true" label="现二级货主" align="center" width="220"></el-table-column>
            <el-table-column prop="warehouseName" :show-overflow-tooltip="true" label="仓位" align="center" width="120"></el-table-column>
            <el-table-column prop="plateNumber" :show-overflow-tooltip="true" label="车船号" align="center" width="120"></el-table-column>
            <el-table-column prop="shipForecastNo" :show-overflow-tooltip="true" label="预报编号" align="center" width="300"></el-table-column>
            <el-table-column prop="productTypeName" :show-overflow-tooltip="true" label="货物类型" align="center" width="120"></el-table-column>
            <el-table-column prop="steelMillName" :show-overflow-tooltip="true" label="产地" align="center" width="100"></el-table-column>
            <el-table-column prop="specification" label="规格" align="center" width="120"></el-table-column>
            <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
            <el-table-column prop="number" label="件数" align="center" width="70" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="allWeight" label="总重量(吨)" align="center" width="120"></el-table-column>
            <el-table-column prop="weight" label="理重(吨)" align="center" width="120"></el-table-column>
            <el-table-column prop="weighingWeight" label="过磅净重(吨)" align="center" width="120"></el-table-column>
            <el-table-column prop="changeNo" label="转货单号" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="loadFeePayer" label="装卸费付费方" align="center" width="140"></el-table-column>
            <el-table-column prop="changeFeePayer" label="转货费付费方" align="center" width="140"></el-table-column>
            <el-table-column prop="approverName" label="操作人" :show-overflow-tooltip="true" align="center" width="150"></el-table-column>
            <el-table-column prop="recordRemark" label="记录备注" :show-overflow-tooltip="true" align="center" width="150"></el-table-column>

          </el-table>
        </div>
      </div>
      <!-- 分页-->
      <div class="pags">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
    </div>
    <!-- 查看单据 -->
    <div class="addMarkBox">
      <el-dialog title="查看凭证" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="80%" center>
        <div class="img_box" v-if="!imgFlag">
          <div>暂未上传凭证</div>
        </div>
        <div class="box1" v-else>
          <div class="leftbox img_box">
            <div v-for="(item,index) in imgData" :key="index" @click="handChange(item.url,item.urlPrimary)" class="imgbox">
              <div v-if="item.urlPrimary.substring(item.urlPrimary.length-3)==='pdf'">
              </div>
              <div v-else>
                <img :src="item.url" alt />
              </div>
            </div>
          </div>
          <div class="rightbox">
            <div v-if="pdfFlag" class="pdfbox">
              <iframe :src="path" frameborder="0" style="width: 100%; height:100%"></iframe>
            </div>
            <div class="imgDialog" v-else>
              <img :src="path" alt />
            </div>
          </div>
        </div>
        <div style="width:80px;margin:15px auto;">
          <el-button type="primary" @click="lookQuXiao">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 备注 -->
    <bei-zhu v-if="beizhuMark" @shuaxin="chaxun" :beizhuMark.sync="beizhuMark" :beizhuName="beizhuName" :selectId="selectId"></bei-zhu>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  zidian,
  getImgShow,
  getSBillFileUrl,
  JfgetChangeStorkExpList,
  JfgetChangeStorkExpNumber,
  JfrevokeChangeStorkExp,
  getVirtualBalingList
} from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import {
  dateTimeFormat
} from '@/utils/util'
import beiZhu from './beizhu.vue'

export default {
  name: 'ZHRecord',
  components: {
    beiZhu
  },
  data () {
    return {
      beizhuMark: false,
      beizhuName: '转货记录YYC',
      selectList: [],
      selectId: [],
      path: '',
      imgFlag: true,
      imgData: [],
      pdfFlag: false,
      addMarkLookBox: false,
      lookFlag: false,
      imgList: [],
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      total: 0,
      formData: {
        changeNo: '',
        changeStatus: '',
        approverDateStart: '',
        approverDateEnd: '',
        oldPrimaryCustomerId: '',
        oldSecondaryCustomerId: '',
        newPrimaryCustomerId: '',
        newSecondaryCustomerId: '',
        productType: '',
        changeBillNo: '',
        source: '',
        changeType: '',
        customerChangNo: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      SHData: [],
      detailsData: [],
      HwData: [],
      ShData: [],
      SjData: [],
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d',
        '00cM0D0100',
        '00cM0D0200'
      ],
      btnFlg: [],
      allWeight: 0,
      number: 0,
      h: '400px',
      changeTypeOption: [
        {
          id: 1,
          name: '转货'
        },
        {
          id: 2,
          name: '回购'
        },
        {
          id: 3,
          name: '钢厂转货'
        }

      ],
      xuanzhongArr: null
    }
  },
  props: {
    ZHVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 选择数据
    selectGoods (selection) {
      this.selectList = selection
    },
    beizhuBtn () {
      if (this.selectList.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.beizhuMark = true
        this.selectId = []
        this.selectList.forEach(item => {
          this.selectId.push(item.changeDetailId)
        })
      }
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },

    JfgetChangeStorkExpNumbers () {
      JfgetChangeStorkExpNumber({ ...this.formData, ...this.pageInfo })
        .then(res => {
          this.allWeight = res.totalAllWeight
          this.number = res.totalNumber
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 查看凭证-取消
    lookQuXiao () {
      this.addMarkLookBox = false
    },
    // 查看凭证-放大
    handChange (url, urlPrimary) {
      this.path = url
      let str = urlPrimary.substring(urlPrimary.length - 3)
      if (str === 'pdf') {
        this.pdfFlag = true
      } else {
        this.pdfFlag = false
      }
    },
    // 点击凭证放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    },
    // 查看图片
    handleClick (row) {
      this.getImgShowB(row)
    },
    getImgShowB (row) {
      getImgShow({
        businessId: row.changeId,
        businessType: 'empty_change'
      })
        .then((res) => {
          this.imgData = []
          this.imgFlag = true
          if (res.length < 1) {
            this.imgFlag = false
            return
          }
          this.imgData = res
          this.seen3 = false
          this.seen2 = true
          if (row.sourceName == '手动') {
            this.addMarkLookBox = true
            if (this.imgData[0].urlPrimary.substring(this.imgData[0].urlPrimary.length - 3) === 'pdf') {
              this.pdfFlag = true
            } else {
              this.pdfFlag = false
            }
            this.path = this.imgData[0].url
          } else {
            let formData = new FormData()
            formData.append('url', res[0].urlPrimary)
            getSBillFileUrl(formData).then(res => {
              this.$router.push({
                // 核心语句
                path: '/pdf', // 跳转的路径
                query: {
                  // 路由传参时push和query搭配使用 ，作用时传递参数
                  path: res
                }
              })
            })
          }
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 分页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetChangeStorkExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetChangeStorkExpLists()
    },
    chaxun () {
      this.JfgetChangeStorkExpLists()
    },
    chongzhi () {
      this.formData.changeNo = ''
      this.formData.approverDateStart = ''
      this.formData.approverDateEnd = ''
      this.formData.oldPrimaryCustomerId = ''
      this.formData.oldSecondaryCustomerId = ''
      this.formData.newPrimaryCustomerId = ''
      this.formData.newSecondaryCustomerId = ''
      this.formData.productType = ''
      this.formData.changeBillNo = ''
      this.formData.source = ''
      this.formData.changeStatus = ''
      this.formData.changeType = ''
      this.formData.customerChangNo = ''
      this.JfgetChangeStorkExpLists()
    },
    // 导出
    daochu () {
      this.isDisableYH = true
      setTimeout(() => {
        this.isDisableYH = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
      let form = {
        changeNo: this.formData.changeNo,
        approverDateStart: this.formData.approverDateStart,
        approverDateEnd: this.formData.approverDateEnd,
        oldPrimaryCustomerId: this.formData.oldPrimaryCustomerId,
        oldSecondaryCustomerId: this.formData.oldSecondaryCustomerId,
        newPrimaryCustomerId: this.formData.newPrimaryCustomerId,
        newSecondaryCustomerId: this.formData.newSecondaryCustomerId,
        productType: this.formData.productType,
        changeBillNo: this.formData.changeBillNo,
        source: this.formData.source,
        changeStatus: this.formData.changeStatus,
        changeType: this.formData.changeType,
        customerChangNo: this.formData.customerChangNo,
        notHiddenColumnList: ['customerChangNo', 'changeFeePayer', 'loadFeePayer']
      }
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportChangeStorkExpList',
        { ...form },
        '转货记录信息表'
      )
    },
    // 撤销
    chexiao () {
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请选择一条数据', type: 'error' })
        return
      }
      this.$confirm('确定撤销转货吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        JfrevokeChangeStorkExp({
          changeDetailId: this.xuanzhongArr.changeDetailId // 主键id
        }).then((res) => {
          this.$message.success('撤销成功')
          this.chaxun()
        }).catch((err) => {
          this.$message.error(err.message)
        })
      }).catch(() => {
      })
    },
    // 列表
    JfgetChangeStorkExpLists () {
      JfgetChangeStorkExpList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        changeNo: this.formData.changeNo,
        approverDateStart: this.formData.approverDateStart,
        approverDateEnd: this.formData.approverDateEnd,
        oldPrimaryCustomerId: this.formData.oldPrimaryCustomerId,
        oldSecondaryCustomerId: this.formData.oldSecondaryCustomerId,
        newPrimaryCustomerId: this.formData.newPrimaryCustomerId,
        newSecondaryCustomerId: this.formData.newSecondaryCustomerId,
        productType: this.formData.productType,
        changeBillNo: this.formData.changeBillNo,
        source: this.formData.source,
        changeStatus: this.formData.changeStatus,
        changeType: this.formData.changeType,
        customerChangNo: this.formData.customerChangNo
      })
        .then(res => {
          this.detailsData = res.list
          this.total = res.total
          this.xuanzhongArr = null
          this.JfgetChangeStorkExpNumbers()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({})
        .then((res) => {
          this.SHData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.HwData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    zidiansj () {
      zidian({
        groupNo: 'source'
      })
        .then((res) => {
          this.SjData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.JfgetChangeStorkExpLists()
    this.getRelationCustomerS()
    this.zidiansj()
    this.JfgetChangeStorkExpNumbers()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.box1 {
  overflow: hidden;
}
.leftbox {
  width: 250px;
  float: left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y: auto;
}
.rightbox {
  margin-left: 50px;
  width: 850px;
  float: left;
  .pdfbox {
    height: calc(100vh - 250px);
  }
}
.img_box {
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    padding: 2px;
    img {
      width: 150px;
      height: 150px;
      margin-left: 50px;
    }
  }
}
.imgDialog {
  width: 100%;
  text-align: center;
  img {
    height: calc(100vh - 250px);
  }
}
</style>
